import { ImmutableObject } from 'common/state/interfaces';
import {
  FieldNecessity,
  RequiredProfileInfo,
} from 'modules/corporate-settings/constants/requiredFields';

export enum IntegrateServices {
  SENDGRID = 'SENDGRID',
  TWILIO = 'TWILIO',
  PAYEEZY = 'PAYEEZY',
  ZENDESK_API = 'ZENDESK_API',
  ZENDESK_WIDGET = 'ZENDESK_WIDGET',
  ITRANSACT = 'ITRANSACT',
  COMMERCEHUB = 'COMMERCEHUB',
}

export enum BankCode {
  COMMERCEHUB = 'COMMERCEHUB',
  ITRANSACT = 'ITRANSACT',
  ZIONS = 'ZIONS',
}

export interface IMessagingSettings {
  // Sendgrid
  email: string;
  emailEnabled: boolean;
  emailSenderName: string;
  sendgridApiKey: string;

  // Twilio
  smsEnabled: boolean;
  phoneNumber: string;
  sid: string;
  token: string;

  bankCode: BankCode;

  // Payeezy
  payeezyEnabled: boolean;
  payeezyUrl: string;
  payeezyApiKey: string;
  payeezyApiSecret: string;
  payeezyMerchantId: string;
  payeezyTransarmorToken: string;
  payeezyPzSecret: string;
  payeezyReportToken: string;
  payeezyUsePeakSettings: boolean;

  // iTransact
  iTransactUsePeakSettings: boolean;
  iTransactApiKey: string;
  iTransactApiUsername: string;
  iTransactGatewayId: string;

  // Campaign Settings
  automaticCampaignEnabled: boolean;
  campaignEnabled: boolean;
  manualCampaignEnabled: boolean;
  scheduledCampaignEnabled: boolean;
  triggeredCampaignEnabled: boolean;

  // Commercehub
  commerceHubUsePeakSettings: boolean;
  commerceHubApiKey: string | null;
  commerceHubApiSecret: string | null;
  commerceHubMerchantId: string | null;
  commerceHubTerminalId: string | null;
}

export interface IMessagingSettingsImt extends ImmutableObject<IMessagingSettings> {
  get<K extends keyof IMessagingSettings>(key: K): IMessagingSettings[K];
}

export interface IRequiredFieldInfo {
  id?: string;
  fieldType: RequiredProfileInfo;
  necessity: FieldNecessity;
}
export type TShortProfileFieldInfo = {
  [key in RequiredProfileInfo]: FieldNecessity;
};

export type TShortProfileFieldInfoImt = ImmutableObject<TShortProfileFieldInfo>;

export interface IRequiredFieldUpdateDto {
  fieldId: string;
  fieldNecessity: FieldNecessity;
}

export type IRequiredFieldInfoImt = ImmutableObject<IRequiredFieldInfo>;

export enum EServicesSettingsType {
  AccountUpdater = 'ACCOUNT_UPDATER',
  ChargebackRepresentments = 'CHARGEBACK_REPRESENTMENTS',
  Checkin = 'CHECKIN',
  ClientClearOwnCreditCards = 'CLIENT_CLEAR_OWN_CREDIT_CARDS',
  Collections = 'COLLECTIONS',
  DayCare = 'DAY_CARE',
  EmployeeTimeClock = 'EMPLOYEE_TIME_CLOCK',
  InvoiceBilling = 'INVOICE_BILLING',
  InvoiceOwn = 'INVOICE_OWN',
  PastDue = 'PAST_DUE',
  PayerService = 'PAYER_SERVICE',
  Pos = 'POS',
  RecurringBilling = 'RECURRING_BILLING',
  Resubmits = 'RESUBMITS',
  Scheduler = 'SCHEDULER',
  Splits = 'SPLITS',
}

export interface IServicesSettingsItem {
  type: EServicesSettingsType;
  value: boolean;
}

export interface IClientServicesSettings {
  ACCOUNT_UPDATER: boolean;
  CHARGEBACK_REPRESENTMENTS: boolean;
  CHECKIN: boolean;
  CLIENT_CLEAR_OWN_CREDIT_CARDS: boolean;
  COLLECTIONS: boolean;
  DAY_CARE: boolean;
  EMPLOYEE_TIME_CLOCK: boolean;
  INVOICE_BILLING: boolean;
  INVOICE_OWN: boolean;
  PAST_DUE: boolean;
  PAYER_SERVICE: boolean;
  POS: boolean;
  RECURRING_BILLING: boolean;
  RESUBMITS: boolean;
  SCHEDULER: boolean;
  SPLITS: boolean;
}

export interface IClientServicesSettingsData {
  clientServices: Partial<IClientServicesSettings>;
}
